var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMainSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_3364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4944 5.08258C21.9885 5.08258 22.4624 5.27887 22.8118 5.62826C23.1612 5.97765 23.3575 6.45153 23.3575 6.94564C23.3575 7.43976 23.1612 7.91364 22.8118 8.26303C22.4624 8.61242 21.9885 8.80871 21.4944 8.80871C21.0003 8.80871 20.5264 8.61242 20.177 8.26303C19.8276 7.91364 19.6313 7.43976 19.6313 6.94564C19.6313 6.45153 19.8276 5.97765 20.177 5.62826C20.5264 5.27887 21.0003 5.08258 21.4944 5.08258Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20388 12.7137C1.95811 14.1047 1.93202 16.2038 3.0747 17.6818C5.29425 20.5631 7.87671 23.1456 10.758 25.3651C12.236 26.5078 14.3351 26.4817 15.7261 25.2359C19.4865 21.8723 23.02 18.2633 26.3034 14.4326C26.6349 14.0517 26.839 13.5766 26.8871 13.0739C27.0908 10.8431 27.5119 4.41682 25.7668 2.67299C24.0218 0.929161 17.5967 1.34897 15.366 1.55391C14.8632 1.60207 14.3882 1.80618 14.0072 2.13767C10.1765 5.42065 6.56756 8.95371 3.20388 12.7137Z",
    fill: "#FE4755",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8836 14.2326C16.9109 13.7333 17.0501 12.8229 16.2924 12.1299M16.2924 12.1299C16.0033 11.8787 15.6667 11.6882 15.3025 11.5697C13.7412 11.0195 11.8248 12.8602 13.1811 14.5456C13.9102 15.4523 14.4728 15.7305 14.4182 16.7589C14.3809 17.4818 13.6705 18.2382 12.734 18.5264C11.9204 18.7773 11.0224 18.4456 10.4548 17.811C9.7605 17.0359 9.8313 16.3056 9.82509 15.9876M16.2924 12.1299L17.1469 11.2753M10.5144 17.9078L9.70337 18.7189",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_3364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    fill: "white",
    transform: "translate(0.583496 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainSale);
export default __webpack_public_path__ + "static/media/icon-main-sale.5109ac7f8d63455f2a470cfd26b409b0.svg";
export { ForwardRef as ReactComponent };